import React from "react";
import dragAndDrop from "../../assets/images/drag-and-drop.png";
import Dropzone from "react-dropzone";

const DragAndDrop = ({ setFileName, onsubmit }) => {
  return (
    <div className="upload-box-wrapper">
      <div className="drag-n-drop-box d-flex justify-content-center align-items-center">
        <div className="drag-n-drop-content text-center">
          <Dropzone
            onDrop={(acceptedFiles) => {
               onsubmit(acceptedFiles[0]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <img
                  src={dragAndDrop}
                  alt="drag and drop icon"
                  className="img-fluid"
                />
                <input {...getInputProps()} />
                <p>Drag and Drop here</p>
              </div>
            )}
          </Dropzone>
        </div>
      </div>
      <div className="or-line">
        <div>
          <hr />
          <span className="px-3">OR</span>
        </div>
      </div>
      <div className="select-file-box">
        {/* <button className="upload-btn">SELECT DOCUMENTS</button> */}
        <label className="upload-btn">
          <input
            type="file"
            className="d-none"
            onChange={(e) => {
              setFileName(e.target.files[0]);
              onsubmit(e.target.files[0]);
            }}
          />
          SELECT DOCUMENTS
        </label>
      </div>
    </div>
  );
};

export default DragAndDrop;
